module.exports = __webpack_public_path__ + "assets/img/banner.0608b2b0.png";